import classnames from 'classnames';

export type ButtonType =
    | 'default'
    | 'ghost'
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'thermometer'
    | 'white';
export type ButtonProps = {
    type?: 'submit' | 'button' | 'reset';
    variant?: ButtonType;
    children: React.ReactNode;
    disabled?: boolean;
    isCentered?: boolean;
    isLoading?: boolean;
    class?: string;
    className?: string;
    style?: React.CSSProperties;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
};

export function Button({
    type,
    class: _class,
    className,
    variant = 'default',
    disabled,
    isCentered = true,
    isLoading,
    ...props
}: ButtonProps): JSX.Element {
    return (
        <button
            {...props}
            type={type ?? 'button'}
            className={classnames(className, _class, 'btn', {
                'btn-default': variant === 'default',
                'btn-ghost': variant === 'ghost',
                'btn-primary': variant === 'primary',
                'btn-secondary': variant === 'secondary',
                'btn-tertiary': variant === 'tertiary',
                'btn-thermometer': variant === 'thermometer',
                'btn-white': variant === 'white',
                'button--loading': isLoading,
                'self-center': isCentered,
            })}
            disabled={isLoading || disabled}
        />
    );
}
